import Service from './Service';

class ClienteEnvelopeService extends Service {
    acompanharSessoes(
        idSessoes,
        pregaoCallback,
        alteracaoSessaoCallback,
        alteracaoProcessoCallback,
        alteracaoMinutaCallback,
        pedidoVistaCallback,
        ordenacaoProcessosCallback,
        cronometroCallback,
        resultadoJulgamentoLoteCallback
    ) {
        this.getClienteEnvelopeApi().acompanharSessoes(
            idSessoes,
            pregaoCallback,
            alteracaoSessaoCallback,
            alteracaoProcessoCallback,
            alteracaoMinutaCallback,
            pedidoVistaCallback,
            ordenacaoProcessosCallback,
            cronometroCallback,
            resultadoJulgamentoLoteCallback
        );
    }

    estaAcompanhandoSessoes(idSessoes) {
        return this.getClienteEnvelopeApi().estaAcompanhandoSessoes(idSessoes);
    }

    cancelarTodosAcompanhamentos() {
        this.getClienteEnvelopeApi().cancelarTodosAcompanhamentos();
    }

    get clienteEnvelopeId() {
        return this.getClienteEnvelopeApi().clienteEnvelopeId;
    }
}
export default ClienteEnvelopeService;
